import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import BellIconOutline from 'mdi-react/BellOutlineIcon';
import BellIcon from 'mdi-react/BellIcon';
import { AppContext } from '@prisjakt/ui-app-context';
import alertActions from '../../../../areas/sidebar/actions/alert';
import * as S from './styles';

const AlertButton = props => {
  const { linkTo } = useContext(AppContext);
  const {
    product,
    account,
    listAlert,
    createAlertRequest,
    removeAlertRequest,
    text,
    type,
    history,
  } = props;
  const { isAuthenticated } = account || {};
  const { createdAlerts, deletedAlerts } = listAlert;

  let alertId = product.alert ? product.alert.id : null;
  if (deletedAlerts[alertId]) {
    alertId = null;
  }
  if (createdAlerts[product.id]) {
    alertId = createdAlerts[product.id];
  }

  return (
    <S.AlertButton>
      <button
        type="button"
        onClick={() => {
          if (isAuthenticated) {
            if (!alertId) {
              createAlertRequest({
                productId: product.id,
                type,
              });
            } else {
              removeAlertRequest(alertId, product.id);
            }
          } else {
            history.push(linkTo('productAlert', product));
          }
        }}
      >
        {alertId ? <BellIcon height={20} /> : <BellIconOutline height={20} />}
        {text}
      </button>
    </S.AlertButton>
  );
};

AlertButton.propTypes = {
  listAlert: PropTypes.shape({
    createdAlerts: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    deletedAlerts: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  }),
  account: PropTypes.shape({
    isAuthenticated: PropTypes.bool,
  }),
  product: PropTypes.shape({
    alert: PropTypes.shape({
      id: PropTypes.number,
    }),
    id: PropTypes.number,
    pathName: PropTypes.string,
  }),
  createAlertRequest: PropTypes.func.isRequired,
  removeAlertRequest: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  history: PropTypes.object.isRequired,
};

AlertButton.defaultProps = {
  account: {
    isAuthenticated: false,
  },
  listAlert: {
    createdAlerts: {},
    deletedAlerts: {},
  },
  product: {},
  type: 'IN_STOCK',
};

export default connect(
  state => ({
    account: state.areas.account,
    listAlert: state.areas.sidebar,
  }),
  { ...alertActions }
)(memo(withRouter(AlertButton)));
